"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryGetDovEnvVar = void 0;
/**
 * This function is used to avoid having to check if the .env variable is undefined every time you want to read a variable out of the .env file.
 * @param DOT_ENV_VAR The variable to attempt to read from the .env file
 * @returns The value of the variable in the .env file. Returns an empty string if no variable is found
 */
function tryGetDovEnvVar(DOT_ENV_VAR) {
    if ((process === null || process === void 0 ? void 0 : process.env) && process.env[DOT_ENV_VAR] !== undefined)
        return process.env[DOT_ENV_VAR];
    else {
        console.log("Could not find " + DOT_ENV_VAR + " in .env, did you set up your .env correctly?");
        return "";
    }
}
exports.tryGetDovEnvVar = tryGetDovEnvVar;
//# sourceMappingURL=env-helper.js.map